/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_poi_filters__value_label__price_range__usd = /** @type {(inputs: { minAmount: NonNullable<unknown>, maxAmount: NonNullable<unknown> }) => string} */ (i) => {
	return `$${i.minAmount} bis $${i.maxAmount}`
};

const en_poi_filters__value_label__price_range__usd = /** @type {(inputs: { minAmount: NonNullable<unknown>, maxAmount: NonNullable<unknown> }) => string} */ (i) => {
	return `$${i.minAmount} to $${i.maxAmount}`
};

const es_poi_filters__value_label__price_range__usd = /** @type {(inputs: { minAmount: NonNullable<unknown>, maxAmount: NonNullable<unknown> }) => string} */ (i) => {
	return `$${i.minAmount} a $${i.maxAmount}`
};

const fr_poi_filters__value_label__price_range__usd = /** @type {(inputs: { minAmount: NonNullable<unknown>, maxAmount: NonNullable<unknown> }) => string} */ (i) => {
	return `$${i.minAmount} à $${i.maxAmount}`
};

const it_poi_filters__value_label__price_range__usd = /** @type {(inputs: { minAmount: NonNullable<unknown>, maxAmount: NonNullable<unknown> }) => string} */ (i) => {
	return `tra $ ${i.minAmount} e $ ${i.maxAmount}`
};

const nl_poi_filters__value_label__price_range__usd = /** @type {(inputs: { minAmount: NonNullable<unknown>, maxAmount: NonNullable<unknown> }) => string} */ (i) => {
	return `$${i.minAmount}€ tot ${i.maxAmount}`
};

const pt_poi_filters__value_label__price_range__usd = /** @type {(inputs: { minAmount: NonNullable<unknown>, maxAmount: NonNullable<unknown> }) => string} */ (i) => {
	return `$${i.minAmount} e $${i.maxAmount}`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ minAmount: NonNullable<unknown>, maxAmount: NonNullable<unknown> }} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__price_range__usd = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.poi_filters__value_label__price_range__usd(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("poi_filters__value_label__price_range__usd", locale)
	if (locale === "de") return de_poi_filters__value_label__price_range__usd(inputs)
	if (locale === "en") return en_poi_filters__value_label__price_range__usd(inputs)
	if (locale === "es") return es_poi_filters__value_label__price_range__usd(inputs)
	if (locale === "fr") return fr_poi_filters__value_label__price_range__usd(inputs)
	if (locale === "it") return it_poi_filters__value_label__price_range__usd(inputs)
	if (locale === "nl") return nl_poi_filters__value_label__price_range__usd(inputs)
	return pt_poi_filters__value_label__price_range__usd(inputs)
};